export function testBeloeb(value: string | undefined) {
  if (value) {
    // regex to test for numbers with max 2 decimals and comma or dot as decimal separator (danish format)
    const regex = /^-?[0-9]+([,.][0-9]{0,2})?$/;
    return regex.test(value);
  }
  return true;
}

export function testStringNumberNotNegative(value: string | undefined) {
  if (value) {
    return value.indexOf("-") === -1;
  }
  return true;
}

export function requiredIfPredicateIsTruthy(
  value: string | number | undefined,
  predicate: boolean,
) {
  if (predicate) {
    return !!value;
  }
  return true;
}
